"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectProductFlagsClient = void 0;
const tslib_1 = require("tslib");
const qs_1 = tslib_1.__importDefault(require("qs"));
const authenticated_client_1 = require("./authenticated.client");
class ProjectProductFlagsClient extends authenticated_client_1.AuthenticatedClient {
    getProjectProductFlag(projectId, featureName) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/projects/${projectId}/product-flags/${featureName}`);
            return response.payload;
        });
    }
    setProjectProductFlag(projectId, featureName, value) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.httpPut(`/v1/projects/${projectId}/product-flags/${featureName}`, { value });
        });
    }
    bulkGetProjectProductFlags(projectId, flagNames) {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/projects/${projectId}/product-flags/bulk-get`, {
                params: { flagNames },
                paramsSerializer: params => qs_1.default.stringify(params, { arrayFormat: 'comma' }),
            });
            return (_a = response.payload) !== null && _a !== void 0 ? _a : {};
        });
    }
    bulkUpdateProjectProductFlags(projectId, flags) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPut(`/v1/projects/${projectId}/product-flags`, {
                flags,
            });
            return response.payload;
        });
    }
}
exports.ProjectProductFlagsClient = ProjectProductFlagsClient;
//# sourceMappingURL=project-product-flags.client.js.map